module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Breadcrumb', _vm._l((_vm.$store.state.currentPath), function(item) {
    return _c('BreadcrumbItem', {
      key: item.name,
      attrs: {
        "href": item.path
      }
    }, [_vm._v(_vm._s(_vm.itemTitle(item)))])
  }), 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-51a560c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51a560c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/views/main_components/breadcrumbNav.vue
// module id = 1362
// module chunks = 61